import React from 'react';
import styles from './CreateDataProductModal.module.scss';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import restFactory from 'v2/utils/restFactory';
import { DataVendor, DataProduct } from 'v2/models';
import ConfirmationModal from 'v2/common/ConfirmationModal/ConfirmationModal';
import DataProductForm, { DataProductFormFields } from './DataProductForm';
import { TranslationKeys, PostProcessKeys } from 'translations';
import { useTranslation } from 'react-i18next';

interface CreateDataProductModalProps {
  show: boolean;
  dataVendor?: DataVendor;
  onClose?: () => void;
  onSuccess?: (data: DataProduct) => void;
}

const CreateDataProductModal = ({
  show,
  dataVendor,
  onClose,
  onSuccess,
}: CreateDataProductModalProps) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset: resetForm,
    formState: { isValid },
  } = useForm<DataProductFormFields>({ mode: 'onChange' });

  const { isLoading: isDataProductMutateLoading, mutate: dataProductMutate } =
    useMutation(
      async (data: DataProductFormFields) => {
        return await restFactory.post<DataProduct>(
          `/dj/api/v1/data_product/`,
          data
        );
      },
      {
        onSuccess: (data: DataProduct) => {
          toast.success(`New ${t(TranslationKeys.dataProduct_one)} saved.`);
          closeModal();
          onSuccess?.(data);
        },
        onError: () => {
          toast.error(`Error saving ${t(TranslationKeys.dataProduct_one)}.`);
        },
      }
    );

  const onSubmit = async (data: DataProductFormFields) => {
    if (isValid) {
      dataProductMutate(data);
    }
  };

  const closeModal = () => {
    resetForm({
      name: '',
      description: '',
      data_vendor: undefined,
    });
    onClose?.();
  };

  return (
    <ConfirmationModal
      className={styles.viewModals}
      centered={true}
      animation={true}
      show={show}
      onCancel={closeModal}
      okBtnText="Save"
      onOk={handleSubmit(onSubmit)}
      okBtnDisabled={!isValid}
      isLoading={isDataProductMutateLoading}
      title={`Add ${t(TranslationKeys.dataProduct_one, {
        postProcess: PostProcessKeys.TitleCase,
      })}`}
    >
      <DataProductForm register={register} dataVendor={dataVendor} />
    </ConfirmationModal>
  );
};

export default CreateDataProductModal;
